import React, { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

interface RoleRouteProps {
  children: ReactNode;
  allowedProfiles: string[];
}

const RoleRoute: FC<RoleRouteProps> = ({ children, allowedProfiles }) => {
  const authToken = localStorage.getItem("authToken");
  const emp: any = useSelector((state: any) => state.emp);

  // Si no hay token valido -> login
  if (!authToken) return <Navigate to="/" replace />;

  // Si el usuario no tiene perfil permitido -> redirigir a home
  const profile = emp?.profile || "";
  if (!allowedProfiles.includes(profile)) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default RoleRoute;
